import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Links.css';

function Links() {
  const navigate = useNavigate();
  const [hoveredIndex, setHoveredIndex] = useState(null);

  const links = [
    {
      title: 'Yahoo Finance',
      description: 'Comprehensive financial data, news, and analysis',
      url: 'https://ca.finance.yahoo.com',
      icon: '📈',
      category: 'Market Research',
    },
    {
      title: 'Google Finance',
      description: 'Real-time stock quotes, news, and market data',
      url: 'https://www.google.com/finance',
      icon: '🔍',
      category: 'Market Research',
    },
    {
      title: 'Fiscal.ai',
      description: 'Modern all-in-one public company research platform',
      url: 'https://fiscal.ai/',
      icon: '🏢',
      category: 'Market Research',
    },
    {
      title: 'Investopedia',
      description: 'Comprehensive financial education and market analysis',
      url: 'https://www.investopedia.com/',
      icon: '📚',
      category: 'Market Research',
    },
    {
      title: 'CNBC',
      description: 'Breaking financial news and market analysis',
      url: 'https://www.cnbc.com/',
      icon: '📺',
      category: 'Market Research',
    },
    {
      title: 'MSN Money',
      description: 'Financial news and market insights',
      url: 'https://www.msn.com/en-ca/money?id=ab6drw',
      icon: '💰',
      category: 'Market Research',
    },
    {
      title: 'Bloomberg Canada',
      description: 'Professional financial news and market data',
      url: 'https://www.bloomberg.com/canada',
      icon: '🌐',
      category: 'Market Research',
    },
    {
      title: 'Fear & Greed Index',
      description: 'Market sentiment indicator and analysis',
      url: 'https://www.cnn.com/markets/fear-and-greed',
      icon: '😨',
      category: 'Market Research',
    },
    {
      title: 'Questrade',
      description: 'Online brokerage platform for trading and investing',
      url: 'https://login.questrade.com/account/login',
      icon: '💼',
      category: 'Investment',
    },
    {
      title: 'RBC Dominion Securities',
      description: 'RBC investment banking and wealth management services',
      url: 'https://www1.royalbank.com/sgw3/PUBINVH/3m00/ISAMSecureRequest/v1/eBGPublicPage?F6=1&F7=IB&F21=IB&F22=IB&REQUEST=ClientSignin&IDP=IVC&LANGUAGE=ENGLISH&SYSTEM=DSIC',
      icon: '🏦',
      category: 'Investment',
    },
    {
      title: 'TD Bank',
      description: 'TD personal banking and investment services',
      url: 'https://www.td.com/ca/en/personal-banking',
      icon: '🏛️',
      category: 'Banking',
    },
    {
      title: 'RBC',
      description: 'RBC Royal Bank personal banking and financial services',
      url: 'https://www.rbcroyalbank.com/personal.html',
      icon: '🏦',
      category: 'Banking',
    },
    {
      title: 'CIBC',
      description: 'CIBC personal banking, credit, and investment services',
      url: 'https://www.cibc.com/en/personal-banking.html',
      icon: '🏦',
      category: 'Banking',
    },
    {
      title: 'Bank of Montreal',
      description: 'BMO personal banking, credit cards, and investing',
      url: 'https://www.bmo.com/main/personal',
      icon: '🏦',
      category: 'Banking',
    },
    {
      title: 'Bank of Nova Scotia',
      description: 'Scotiabank personal banking and investment services',
      url: 'https://www.scotiabank.com/ca/en/personal.html',
      icon: '🏦',
      category: 'Banking',
    },
    {
      title: 'EQ Bank',
      description: 'Digital banking, savings, and everyday banking services',
      url: 'https://www.eqbank.ca/',
      icon: '🏦',
      category: 'Banking',
    },
    {
      title: 'Tangerine Bank',
      description: 'Online banking, savings, credit cards, and investing',
      url: 'https://www.tangerine.ca/en',
      icon: '🏦',
      category: 'Banking',
    },
    {
      title: 'ChatGPT',
      description: 'OpenAI assistant for writing, coding, research, and analysis',
      url: 'https://chatgpt.com/',
      icon: '🤖',
      category: 'AI Chatbots',
    },
    {
      title: 'Claude',
      description: 'Anthropic AI assistant for writing, coding, and research',
      url: 'https://claude.ai/',
      icon: '🤖',
      category: 'AI Chatbots',
    },
    {
      title: 'Cursor',
      description: 'AI-powered code editor and development environment',
      url: 'https://www.cursor.com/',
      icon: '⌨️',
      category: 'Developer Tools',
    },
    {
      title: 'Grok',
      description: 'xAI assistant for search, answers, and research',
      url: 'https://grok.com/',
      icon: '🤖',
      category: 'AI Chatbots',
    },
    {
      title: 'Gemini',
      description: 'Google AI assistant for writing, research, and productivity',
      url: 'https://gemini.google.com/',
      icon: '✨',
      category: 'AI Chatbots',
    },
    {
      title: 'Apple Developer',
      description: 'Apple Developer documentation, tools, and resources',
      url: 'https://developer.apple.com',
      icon: '🍎',
      category: 'Developer Tools',
    },
    {
      title: 'Air Canada',
      description: 'Canadian airline flights, bookings, and flight status',
      url: 'https://www.aircanada.com/',
      icon: '✈️',
      category: 'Travel',
    },
    {
      title: 'WestJet',
      description: 'Canadian airline flights, vacation packages, and travel deals',
      url: 'https://www.westjet.com/',
      icon: '✈️',
      category: 'Travel',
    },
    {
      title: 'Google Flights',
      description: 'Flight search, fare tracking, and travel planning',
      url: 'https://www.google.com/travel/flights',
      icon: '🧳',
      category: 'Travel',
    },
    {
      title: 'Skyscanner',
      description: 'Compare flights, hotels, and car rentals',
      url: 'https://www.skyscanner.ca/',
      icon: '🧳',
      category: 'Travel',
    },
    {
      title: 'Expedia',
      description: 'Book flights, hotels, vacation packages, and car rentals',
      url: 'https://www.expedia.ca/',
      icon: '🌎',
      category: 'Travel',
    },
    {
      title: 'Booking.com',
      description: 'Hotel, apartment, and travel accommodation bookings',
      url: 'https://www.booking.com/',
      icon: '🏨',
      category: 'Travel',
    },
  ];

  const linkGroups = [
    {
      title: 'Banks',
      category: 'Banking',
      description: 'Canadian personal banking and online banking services.',
    },
    {
      title: 'Investments',
      category: 'Investment',
      description: 'Brokerage, wealth management, and investment account access.',
    },
    {
      title: 'Market Research',
      category: 'Market Research',
      description: 'Market data, financial news, research, and investing education.',
    },
    {
      title: 'AI Chatbots',
      category: 'AI Chatbots',
      description: 'AI assistants for writing, research, analysis, and productivity.',
    },
    {
      title: 'Developer Tools',
      category: 'Developer Tools',
      description: 'Coding tools, documentation, and developer resources.',
    },
    {
      title: 'Travel',
      category: 'Travel',
      description: 'Airlines, flight search, and travel booking services.',
    },
  ];

  const handleLinkClick = (link) => {
    if (link.isInternal) {
      navigate(link.url);
    } else {
      window.open(link.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="links">
      <h1 className="links-title">Useful Links</h1>
      <p className="links-subtitle">
        Quick access to financial resources and market analysis tools
      </p>

      <div className="links-groups">
        {linkGroups.map((group) => (
          <section className="links-group" key={group.title}>
            <div className="links-group-header">
              <h2 className="links-group-title">{group.title}</h2>
              <p className="links-group-description">{group.description}</p>
            </div>
            <div className="links-grid">
              {links
                .filter(link => link.category === group.category)
                .map((link) => (
                  <div
                    key={link.title}
                    className={`links-card${hoveredIndex === link.title ? ' links-card--hover' : ''}`}
                    onClick={() => handleLinkClick(link)}
                    onMouseEnter={() => setHoveredIndex(link.title)}
                    onMouseLeave={() => setHoveredIndex(null)}
                    onKeyDown={(event) => {
                      if (event.key === 'Enter' || event.key === ' ') {
                        event.preventDefault();
                        handleLinkClick(link);
                      }
                    }}
                    role="link"
                    tabIndex={0}
                  >
                    <div className="links-card-header">
                      <span className="links-card-icon">{link.icon}</span>
                      <h3 className="links-card-title">{link.title}</h3>
                    </div>
                    <p className="links-card-description">{link.description}</p>
                    <div className="links-card-footer">
                      <span className="links-card-category">{link.category}</span>
                      <span className="links-card-external">
                        {link.isInternal ? '→' : '↗'}
                      </span>
                    </div>
                  </div>
                ))}
            </div>
          </section>
        ))}
      </div>
    </div>
  );
}

export default Links;
